import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function findByNat(sub, nat) {
  return sub.find((s) => s.nat === nat);
}
// Total cells: a 0 (no price / suspended) reads "-", like the reference.
const dash = (v) => (Number(v) ? v : '-');
function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function bookOf(exposures, nat) {
  return roundBook(exposures?.[nat] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// 2 Cards Teenpatti bet table. sub: patti2 (Player A/B back-lay), Baccarat
// (Mini Baccarat A/B back only), total (Total A/B — lay/back me bhav[lbhav/bbhav]
// + total[l/b]), plus (Color Plus back + book). book-black hamesha.
// Web = teen1day left/right, mobile = flat stack (dono CSS se switch).
const BetTableTeenpatti2Cards = memo(function BetTableTeenpatti2Cards({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const playerA = findByNat(sub, 'Player A');
  const playerB = findByNat(sub, 'Player B');
  const mbaccA = findByNat(sub, 'Mini Baccarat A');
  const mbaccB = findByNat(sub, 'Mini Baccarat B');
  const totalA = findByNat(sub, 'Total A');
  const totalB = findByNat(sub, 'Total B');
  const colorPlus = findByNat(sub, 'Color Plus');
  const cpBook = bookOf(exposures, 'Color Plus');

  const nameBook = (nat) => {
    const book = bookOf(exposures, nat);
    return <div className="float-right"><span className={`mr-2 ${bookCls(book)}`}>{fmtBook(book)}</span></div>;
  };

  // Player A/B — back + lay
  const twoWay = (label, item) => (
    <div className="casino-box-row">
      <div className="casino-nation-name"><b>{label}</b> {nameBook(label)}</div>
      {' '}
      <div className="casino-bl-box">
        <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
          <span className="casino-box-odd">{item?.b ?? 0}</span>
        </div>
        {' '}
        <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
          <span className="casino-box-odd">{item?.l ?? 0}</span>
        </div>
      </div>
    </div>
  );

  // Mini Baccarat A/B — back only (full width)
  const oneWay = (label, item) => (
    <div className="casino-box-row">
      <div className="casino-nation-name"><b>{label}</b> {nameBook(label)}</div>
      {' '}
      <div className="casino-bl-box casino-bl-boxfull">
        <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
          <span className="casino-box-odd">{item?.b ?? 0}</span>
        </div>
      </div>
    </div>
  );

  // Total A/B — lay/back: <span>{bhav}</span> <span class="casino-box-odd">{total}</span>
  const totalWay = (label, item) => (
    <div className="casino-box-row">
      <div className="casino-nation-name"><b className="pointer">{label}</b> {nameBook(label)}</div>
      {' '}
      <div className="casino-bl-box total-odds">
        <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
          <span>{item?.lbhav ?? 0}</span> <span className="casino-box-odd">{dash(item?.l)}</span>
        </div>
        {' '}
        <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
          <span>{item?.bbhav ?? 0}</span> <span className="casino-box-odd">{dash(item?.b)}</span>
        </div>
      </div>
    </div>
  );

  // Color Plus extra — the cell reads "Color Plus" on web and mobile (reference;
  // the feed's b is a placeholder, Color Plus pays by hand)
  const colorPlusRow = (label) => (
    <div className="teenpatti2cardsextra mt-3">
      <div className="casino-bl-box casino-bl-boxfull">
        <div className={`back casino-bl-box-item${suspCls(colorPlus)}`} onClick={isSusp(colorPlus) ? undefined : () => handleBet(colorPlus.sid, 'back', colorPlus.b, colorPlus)}>
          <span className="casino-box-odd">{label}</span>
        </div>
      </div>
      {' '}
      <div className="teenpatti2cardsextra-book"><span className={bookCls(cpBook)}>{fmtBook(cpBook)}</span></div>
    </div>
  );

  return (
    <>
      {/* Mobile — flat stack */}
      <div className="d-none-big">
        {twoWay('Player A', playerA)}
        {' '}
        {twoWay('Player B', playerB)}
        {' '}
        {oneWay('Mini Baccarat A', mbaccA)}
        {' '}
        {oneWay('Mini Baccarat B', mbaccB)}
        {' '}
        {totalWay('Total A', totalA)}
        {' '}
        {totalWay('Total B', totalB)}
        {' '}
        {colorPlusRow('Color Plus')}
      </div>

      {/* Desktop — teen1day left/right */}
      <div className="d-none-small">
        <div className="teen1daycasino-container">
          <div className="teen1dayleft">
            {twoWay('Player A', playerA)}
            {' '}
            {oneWay('Mini Baccarat A', mbaccA)}
            {' '}
            {totalWay('Total A', totalA)}
          </div>
          {' '}
          <div className="teen1daycenter"></div>
          {' '}
          <div className="teen1dayright">
            {twoWay('Player B', playerB)}
            {' '}
            {oneWay('Mini Baccarat B', mbaccB)}
            {' '}
            {totalWay('Total B', totalB)}
          </div>
        </div>
        {' '}
        {colorPlusRow('Color Plus')}
      </div>
    </>
  );
});

export default BetTableTeenpatti2Cards;
